/**
 * wordBars — wraps every word of the matched elements in <span class="wbar">
 * so each word sits on its own solid bar (tape-over-video readability).
 *
 * Only text nodes are touched; existing child elements (links, <br>, the
 * hero's per-letter spans) are left alone. Safe to call more than once.
 *
 *   wrapWords('.card__title, .hero__tags');
 */
export function wrapWords(selector, { className = 'wbar' } = {}) {
  const els = document.querySelectorAll(selector);
  els.forEach((el) => {
    if (el.dataset.wordBars === '1') return;
    el.dataset.wordBars = '1';
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
      acceptNode: (n) => (n.nodeValue.trim() && !n.parentElement.closest(`.${className}`)
        ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT),
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (const node of nodes) {
      const frag = document.createDocumentFragment();
      const parts = node.nodeValue.split(/(\s+)/);
      for (const part of parts) {
        if (!part) continue;
        if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); continue; }
        const s = document.createElement('span');
        s.className = className;
        s.textContent = part;
        frag.appendChild(s);
      }
      node.parentNode.replaceChild(frag, node);
    }
  });
}
